import {IRouteStore} from '../../router/routing.infra';
import {getRootStore} from '../../app.bootstrap';
import {BrowserUtilsExtended} from '../../services/browser-utils-extended/browser-utils-extended.service';
import {HistoryState} from './_contracts/HistoryState';
import {HistoryController} from './HistoryController';

export interface IHistoryStore extends IRouteStore {
    historyController: HistoryController;
    dispose(): void;
}

export class HistoryStore implements IHistoryStore {
    public historyController: HistoryController;

    constructor(currentUser: any, accountData: any) {
        const rootStore = getRootStore();
        const historyState = new HistoryState();
        this.historyController = new HistoryController(historyState, {
            historyService: rootStore.dbHistoryService,
            videoRecordingsService: rootStore.dbVideoRecordingsService,
            accountData,
            tsStateHelper: rootStore.tsReactStateHelper,
            tsUrlUtils: new BrowserUtilsExtended(rootStore.browserUtilsService),
            tsSessionData: rootStore.tsSessionData,
            browserUtilsService: rootStore.browserUtilsService,
            redirectionService: rootStore.redirectionService,
            tsAppUserService: rootStore.tsAppUserService,
            authService: rootStore.authService,
            appState: rootStore.appState,
            displayTabletAsDesktop: rootStore.displayTabletAsDesktop,
            currentUser
        });
    }

    dispose(): void {
        // Cleanup if needed
    }
}
